





























































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ColDef,
  ColumnApi,
} from 'ag-grid-community';

import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import {
  DataApi,
  DevicesApi,
  ParamApiGenerarMovimiento,
  paramApiGenerarEncomienda,
} from './models/Add.model';
import { fetchAdd } from './fetchAdd';
import AddEquipo from './AddEquipos.vue';
import MenuItem from '@/components/MenuItem.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  codigoAccionesMenuItem as allActions,
  PermisoAccion,
} from '@/views/base/VariablesPermisos';
import store from '@/store';
import { actionsEvent } from '@/setup';
import Confirmation from '@/components/Confirmation.vue';

@Component({
  components: {
    GridComponent: AgGridVue,
    DatePicker,
    AddEquipo,
    MenuItem,
    Confirmation,
  },
})
export default class AddModalGestionarDespacho extends Vue {
  @Prop({ required: true, default: true }) dialog!: boolean;
  @Prop({ required: true, default: null }) data!: DataApi;

  readonly $snotify: Snotify = null;
  readonly loadingService: LoadingService = new LoadingService();
  readonly timeout: { timeout: number } = { timeout: 3000 };

  // ── Stepper ──────────────────────────────────────────────────────────────
  currentStep: number = 1;
  dialogPopUp: boolean = false;

  // ── Step 1: Agregar Equipo ────────────────────────────────────────────────
  columnApi_equipo: ColumnApi = null;
  gridOptions_equipo: GridOptions = null;
  gridEvent_equipo: GridReadyEvent = null;
  gridApi_equipo: GridApi = null;
  columnDefs_equipo: ColDef[] = [];
  deviceList: DevicesApi[] = [];

  modalDeviceList: boolean = false;
  loading_equipo: boolean = false;
  quickSearch: string = '';
  now: string = moment().format('YYYY-MM-DD');

  objParam_equipo: {
    despachador?: string;
    fecha_despachador?: moment.Moment;
  } = {};
  users: any = [];
  propietario: string = '';
  validateFieldEmpty_equipo: Record<string, boolean> = {
    fecha_despacho: false,
  };

  readonly funcionalidades: Funcionalidades = Funcionalidades.ModalAdd;
  readonly codigoAccionesMenuItem: number[] = Object.values(allActions);

  eliminar: PermisoAccion = { accionCodigo: 5, visible: false };
  readonly accionesTotales: PermisoAccion[] = [this.eliminar];

  // ── Step 2: Generar Movimiento ────────────────────────────────────────────
  loading_movi: boolean = false;
  disabledBtn_movi: boolean = false;
  step2Initialized: boolean = false;
  generarMovimiento: boolean = false;

  paramApi_movi: ParamApiGenerarMovimiento = {
    usuario: { id: '', nombre: '', rut: '' },
    operacion: { operacion_id: '5', operacion_name: '' },
    origen: { tipoubicaid: '', tipoubicaname: '', tipoubicabaja: '' },
    destino: { tipoubicaid: '', tipoubicaname: '' },
    numDespacho: { despanumero: '', despaseguimiento: '' },
    movicajanro: '',
    estado: { estado_id: '1', estado_name: '' },
    moviobs: '',
  };

  listApi_movi: Record<string, any[]> = {
    operaciones: [],
    destinos: [],
    destinosDisponibles: [],
    numDespachos: [],
    estados: [],
  };

  rules_movi: Record<string, any> = {
    textareaCounter: (val: string) =>
      val && val.length > 500
        ? 'Solo se permite como máximo 500 caracteres'
        : true,
    destino: (val: any) =>
      !val.tipoubicaid || !val.tipoubicabaja ? 'El destino es requerido' : true,
  };

  // ── Step 3: Generar Encomienda ────────────────────────────────────────────
  loading_enc: boolean = false;
  disabledForm_enc: boolean = false;
  disabledBtn_enc: boolean = false;
  disabledFieldValue_enc: boolean = true;
  activateChange_enc: boolean = false;
  step3Initialized: boolean = false;

  paramApi_enc: paramApiGenerarEncomienda = {
    despanumero: 'Por Asignar',
    despafecha_envia: moment(),
    courrier: { configid: '', configvalor: '' },
    despaseguimiento: '',
    localidad: { locaid: '', locaname: '', locabaja: '' },
    tecnico: { tecnicoid: '', tecniconame: '', estado: '' },
    usuario: { id: '', nombre: '', rut: '' },
    despaobs: '',
    despacargo_sino: false,
    despacargo_valor: '',
    despafecha_recibe: '',
    despareceptor: '',
  };

  listApi_enc: Record<string, any[]> = {
    tecnicos: [],
    localidades: [],
    courriers: [],
  };

  rules_enc: Record<string, any> = {
    observacion: (val: string) =>
      val && val.length > 100
        ? 'Solo se permite como máximo 100 caracteres'
        : true,
    seguimiento: (val: any) =>
      !val || !val.trim() ? '* El orden de seguimiento es requerido' : true,
    localidad: (val: any) =>
      !val.locaid || !val.locaname ? '* La localidad es requerida' : true,
    precio: (val: any) =>
      val && val.length > 11
        ? 'Solo se permite como máximo 10 caracteres más un punto'
        : true,
  };

  // ── Constructor / lifecycle ───────────────────────────────────────────────
  constructor() {
    super();
    this.actions();
    this.columnDefs_equipo = this.colsGridEquipo();
    this.gridOptions_equipo = {
      columnDefs: this.columnDefs_equipo,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReadyEquipo,
    };
  }

  async mounted() {
    try {
      this.loading_equipo = true;
      this.loadingService.showLoading(null, 'getUser');
      await this.getUser();
      this.objParam_equipo.despachador = this.data.despachado_por;
      this.objParam_equipo.fecha_despachador = this.data.fecha_despacho
        ? moment(this.data.fecha_despacho)
        : moment();
      this.validateFieldEmpty_equipo.fecha_despacho = !!this.data
        .fecha_despacho;
    } catch (error) {
      console.error('Error iniciando step 1: ', error);
    } finally {
      this.loading_equipo = false;
      this.loadingService.hideLoading('getUser');
    }
  }

  @Watch('currentStep')
  async onStepChange(newStep: number) {
    if (newStep === 2 && !this.step2Initialized) {
      // Inicializa Generar Movimiento y Generar Encomienda en paralelo
      await Promise.all([this.initStep2(), this.initStep3()]);
      this.step2Initialized = true;
      this.step3Initialized = true;
    }
  }

  // ── Navigation ────────────────────────────────────────────────────────────
  prevStep(): void {
    if (this.currentStep > 1) this.currentStep--;
  }

  nextStep(): void {
    if (this.currentStep === 1) {
      if (!this.objParam_equipo.despachador) {
        this.$snotify.error(
          'Debe seleccionar un Despachado Por antes de continuar',
          { ...this.timeout }
        );
        return;
      }
      if (!this.deviceList.length) {
        this.$snotify.error(
          'Debe agregar al menos un dispositivo antes de continuar',
          { ...this.timeout }
        );
        return;
      }
    }
    if (this.currentStep < 2) this.currentStep++;
  }

  // ── Actions event ─────────────────────────────────────────────────────────
  actions() {
    actionsEvent.onEliminar(this.handleDeleteDevice);
  }

  // ── Step 1: Agregar Equipo — lógica ──────────────────────────────────────
  async getUser() {
    const userId = JSON.parse(
      window.localStorage.getItem('user').replace(/'/g, '"')
    ).id;
    try {
      const result = await fetchAdd({
        endpoint: 'get_user',
        body: { user_id: userId, add: this.data.nombre_add },
      });
      const {
        MENSAJE_RESPUESTA,
        CODIGO_RESPUESTA,
        USERS,
        PROPIETARIO,
      } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { ...this.timeout });
        return;
      }
      this.users = USERS;
      this.propietario = PROPIETARIO;
      this.objParam_equipo.despachador = PROPIETARIO;
    } catch (error) {
      console.error('Error validando el usuario: ', error);
    }
  }

  handleMainGridReadyEquipo(event: GridReadyEvent): void {
    this.gridApi_equipo = event.api;
    this.columnApi_equipo = event.columnApi;
    this.gridEvent_equipo = event;
    this.gridApi_equipo.setRowData(this.deviceList);
    this.gridApi_equipo.setDomLayout('autoHeight');
  }

  handleSearchEquipo(): void {
    if (!this.gridApi_equipo) return;
    this.gridApi_equipo.setQuickFilter(this.quickSearch);
    this.gridApi_equipo.setDomLayout('autoHeight');
  }

  handleSelected(devices: DevicesApi[]): void {
    for (const device of devices) {
      if (!this.deviceList.includes(device)) {
        this.deviceList.push(device);
        this.reloadGridEquipo(this.deviceList);
      }
    }
  }

  handleChangeDateEquipo(): void {
    this.$forceUpdate();
  }

  reloadGridEquipo(data: DevicesApi[]): void {
    this.gridApi_equipo.setRowData(data);
    this.gridApi_equipo.setDomLayout('autoHeight');
  }

  handleDeleteDevice(params: { data: DevicesApi }): void {
    const serieNumero: string = params.data.serienumero;
    this.deviceList = this.deviceList.filter(
      serie => !serieNumero.includes(serie.serienumero)
    );
    this.reloadGridEquipo(this.deviceList);
  }

  private colsGridEquipo(): ColDef[] {
    const cols = [
      { id: 'serienumero', field: 'Serie Número' },
      { id: 'tipoeqname', field: 'Equipo' },
      { id: 'simserienumero', field: 'SIM' },
      { id: 'simestado', field: 'Estado SIM' },
      { id: 'telconame', field: 'Telco' },
    ];
    const columns: ColDef[] = cols.map(col => ({
      headerName: col.field,
      field: col.id,
      cellStyle: { textAlign: 'left' },
      resizable: false,
      sortable: true,
      width: 200,
      minWidth: 200,
    }));

    columns.push({
      headerName: 'Acciones',
      width: 120,
      minWidth: 120,
      sortable: false,
      resizable: false,
      filter: false,
      enablePivot: false,
      field: 'id',
      cellRendererFramework: MenuItem,
      cellRendererParams: () => ({
        funcionalidad: this.funcionalidades,
        codigoAccionesMenuItem: this.codigoAccionesMenuItem,
        usuario: store.state.user,
      }),
      colId: 'params',
      rowDrag: false,
      pinned: 'right',
      lockVisible: true,
      suppressMovable: true,
      getQuickFilterText: () => '',
      cellStyle: { textAlign: 'center' },
    });

    return columns;
  }

  async handleSaveEquipo(): Promise<void> {
    if (!this.objParam_equipo.despachador) {
      this.$snotify.error('El campo Despachado Por es un campo obligatorio', {
        ...this.timeout,
      });
      return;
    }
    if (!this.deviceList.length) {
      this.$snotify.error('Debe agregar por lo menos un dispositivo', {
        ...this.timeout,
      });
      return;
    }
    const ok = await this.addDevice();
    if (ok) this.handleClosed({ reload: true });
  }

  cargarDispositivosTodos() {
    this.modalDeviceList = true;
  }

  handleClosedModalAddDevices(): void {
    actionsEvent.removeListeners();
    this.actions();
    this.modalDeviceList = false;
  }

  async addDevice(): Promise<boolean> {
    try {
      this.loadingService.showLoading(null, 'addDevices');
      const actual_usuario_id = JSON.parse(
        window.localStorage.getItem('user').replace(/'/g, '"')
      ).id;
      const resp = await fetchAdd({
        endpoint: 'add_devices',
        body: {
          device_list: this.deviceList,
          data: this.data,
          params: this.objParam_equipo,
          actual_usuario_id,
        },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = resp.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { ...this.timeout });
        return false;
      }
      this.$snotify.success(MENSAJE_RESPUESTA, { ...this.timeout });
      return true;
    } catch (err) {
      const msg =
        err instanceof Error && err.message && err.message !== 'Network Error'
          ? err.message
          : 'Ha ocurrido un error inesperado, por favor intente más tarde';
      this.$snotify.error(msg, { ...this.timeout });
      return false;
    } finally {
      this.loadingService.hideLoading('addDevices');
    }
  }

  // ── Step 2: Generar Movimiento — lógica ──────────────────────────────────
  async initStep2(): Promise<void> {
    try {
      this.loading_movi = true;
      const userId = JSON.parse(
        window.localStorage.getItem('user').replace(/'/g, '"')
      ).id;
      this.loadingService.showLoading(null, 'getMoviValues');
      const result = await fetchAdd({
        endpoint: 'get_movi_values',
        body: { user_id: userId, data: this.data },
      });
      const {
        CODIGO_RESPUESTA,
        MENSAJE_RESPUESTA,
        USER,
        OPERACIONES,
        DESTINOS,
        NUM_DESPACHOS,
        ESTADOS,
        UBICA_ORIGEN,
        numero_despacho,
      } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      this.paramApi_movi.usuario = USER[0];
      this.listApi_movi.operaciones = OPERACIONES;
      this.listApi_movi.destinos = DESTINOS;
      this.listApi_movi.destinosDisponibles = DESTINOS.filter(
        (x: any) => x.tipoubicaid !== UBICA_ORIGEN && x.tipoubicabaja !== 't'
      );
      this.paramApi_movi.origen.tipoubicaid = UBICA_ORIGEN;
      this.listApi_movi.numDespachos = NUM_DESPACHOS;
      this.listApi_movi.estados = ESTADOS;
      this.paramApi_movi.numDespacho = numero_despacho;
    } catch (err) {
      console.error('Error iniciando step 2: ', err);
    } finally {
      this.loading_movi = false;
      this.loadingService.hideLoading('getMoviValues');
    }
  }

  handleChangeMovi(): void {
    this.disabledBtn_movi =
      this.paramApi_movi.destino.tipoubicaid &&
      this.paramApi_movi.estado.estado_id
        ? false
        : true;

    if (
      this.paramApi_movi.numDespacho &&
      this.paramApi_movi.numDespacho.despanumero
    ) {
      this.generarMovimiento = false;
    }
  }

  async handleSaveStep2(): Promise<void> {
    // Validar datos del step 1
    if (!this.objParam_equipo.despachador) {
      this.$snotify.error('El campo Despachado Por es un campo obligatorio', {
        timeout: 3000,
      });
      return;
    }
    if (!this.deviceList.length) {
      this.$snotify.error('Debe agregar por lo menos un dispositivo', {
        timeout: 3000,
      });
      return;
    }

    // Validar Generar Movimiento
    if (
      !this.paramApi_movi.destino.tipoubicaid ||
      !this.paramApi_movi.estado.estado_id
    ) {
      this.$snotify.error(
        'Generar Movimiento: Debe llenar todos los datos marcados como obligatorios',
        { timeout: 3000 }
      );
      return;
    }

    // Validar Generar Encomienda (solo si el checkbox está activo y el formulario no está deshabilitado)
    if (this.generarMovimiento && !this.disabledForm_enc) {
      const despaseguimiento = this.paramApi_enc.despaseguimiento
        ? this.paramApi_enc.despaseguimiento.trim()
        : '';
      if (
        !despaseguimiento ||
        !this.paramApi_enc.localidad.locaid ||
        !this.paramApi_enc.tecnico.tecnicoid
      ) {
        this.$snotify.error(
          'Generar Encomienda: Debe llenar todos los datos marcados como obligatorios',
          { timeout: 3000 }
        );
        this.activateChange_enc = true;
        this.disabledBtn_enc = true;
        return;
      }
      if (
        this.paramApi_enc.despaobs &&
        this.paramApi_enc.despaobs.length > 100
      ) {
        this.$snotify.error(
          'El campo observaciones solo permite un máximo de 100 caracteres',
          { timeout: 3000 }
        );
        return;
      }
      if (
        this.paramApi_enc.despacargo_valor &&
        this.paramApi_enc.despacargo_valor.length > 11
      ) {
        this.$snotify.error(
          'El campo valor solo permite como máximo 10 caracteres más un punto',
          { timeout: 3000 }
        );
        return;
      }
    }

    // 1° Guardar equipos (add_devices)
    const devicesOk = await this.addDevice();
    if (!devicesOk) return;

    // 2° Guardar movimiento (insert_devices)
    const moviOk = await this.updateMovimiento();
    if (!moviOk) return;

    // 3° Guardar encomienda (insert_encomienda) — solo si el checkbox está activo
    if (this.generarMovimiento && !this.disabledForm_enc) {
      await this.insertEncomienda();
    } else {
      this.handleClosed({ reload: true });
    }
  }

  async updateMovimiento(): Promise<boolean> {
    const newMovimiento = {
      nombre_ndv: this.data.nombre_ndv,
      id_add: this.data.id,
      estado_conecta: this.data.estado_conecta,
      ...this.paramApi_movi,
    };
    try {
      this.loadingService.showLoading(null, 'updateMovi');
      const result = await fetchAdd({
        endpoint: 'insert_devices',
        body: { ...newMovimiento },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return false;
      }
      this.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
      return true;
    } catch (err) {
      this.$snotify.error('Ocurrió un error inesperado, por favor reintente', {
        timeout: 3000,
      });
      console.error('Error: ', err);
      return false;
    } finally {
      this.loadingService.hideLoading('updateMovi');
    }
  }

  // ── Step 3: Generar Encomienda — lógica ──────────────────────────────────
  async initStep3(): Promise<void> {
    try {
      this.loading_enc = true;
      this.loadingService.showLoading(null, 'addGenerarEncomienda');
      await Promise.all([this.getFiltersEnc(), this.getValuesEnc()]);
    } catch (error) {
      console.error('Error iniciando step 3: ', error);
    } finally {
      this.loading_enc = false;
      this.loadingService.hideLoading('addGenerarEncomienda');
    }
  }

  async getValuesEnc(): Promise<void> {
    const newEncomienda = {
      id_add: this.data.id,
      numero_despacho: this.data.numero_despacho,
      nombre_add: this.data.nombre_add,
    };
    try {
      const result = await fetchAdd({
        endpoint: 'get_encomienda',
        body: { ...newEncomienda },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
      }
      if (Object.keys(LISTA[0]).length === 0) return;

      const {
        despanumero,
        despafecha_envia,
        despacourrier,
        despaseguimiento,
        locaid,
        tecnicoid,
        usuarioid_alta,
        usuariorut_alta,
        nombre,
        despaobs,
        despacargo_sino,
        despacargo_valor,
        despafecha_recibe,
        despareceptor,
      } = LISTA[0];

      this.paramApi_enc.despanumero = despanumero;
      this.paramApi_enc.despafecha_envia = moment(despafecha_envia);
      this.paramApi_enc.courrier.configid = despacourrier;
      this.paramApi_enc.despaseguimiento = despaseguimiento;
      this.paramApi_enc.localidad.locaid = locaid;
      this.paramApi_enc.tecnico.tecnicoid = tecnicoid;
      this.paramApi_enc.usuario.id = usuarioid_alta;
      this.paramApi_enc.usuario.rut = usuariorut_alta;
      this.paramApi_enc.usuario.nombre = nombre;
      this.paramApi_enc.despaobs = despaobs;
      this.paramApi_enc.despacargo_sino = Number(despacargo_sino) === 1;
      this.paramApi_enc.despacargo_valor = despacargo_valor;
      this.paramApi_enc.despafecha_recibe = despafecha_recibe
        ? moment(despafecha_recibe)
        : '';
      this.paramApi_enc.despareceptor = despareceptor;
      this.disabledForm_enc = true;
      this.$snotify.warning(
        `Ya se ha realizado una encomienda anteriormente en la asignación ${this.data.nombre_add}. Puede validar el detalle en el módulo "Encomiendas".`,
        { timeout: 3500 }
      );
    } catch (error) {
      console.error('Error iniciando los valores de encomienda: ', error);
    }
  }

  async getFiltersEnc(): Promise<void> {
    try {
      const userId = JSON.parse(
        window.localStorage.getItem('user').replace(/'/g, '"')
      ).id;
      const result = await fetchAdd({
        serviceClient: 'conectaDespacho',
        endpoint: 'getFilter',
        body: { user_id: userId },
      });
      const {
        CODIGO_RESPUESTA,
        MENSAJE_RESPUESTA,
        TECNICO,
        LOCALIDAD,
        CURRIER,
        USER,
      } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      this.listApi_enc.tecnicos = TECNICO.filter(
        (tecnico: any) => tecnico.estado != '1'
      );
      this.listApi_enc.localidades = LOCALIDAD.filter(
        (localidad: any) =>
          localidad.locabaja !== 't' &&
          !localidad.locaname
            .trim()
            .toLowerCase()
            .includes('santiago')
      );
      this.listApi_enc.courriers = CURRIER;
      this.paramApi_enc.usuario = USER[0];

      const findTecnico = TECNICO.find(
        (tecnico: any) => tecnico.tecnicoid === this.data.tecnicoid
      );
      if (findTecnico) {
        this.paramApi_enc.tecnico = findTecnico;
      } else {
        this.$snotify.error(
          `El técnico ${this.data.nombre_tecnico} no se encuentra asignado en el mantenedor de técnicos`,
          { timeout: 3000 }
        );
        this.disabledBtn_enc = true;
      }
    } catch (err) {
      console.error('Error: ', err);
    }
  }

  handleChangeEnc(): void {
    if (this.activateChange_enc) {
      const despaseguimiento = this.paramApi_enc.despaseguimiento
        ? this.paramApi_enc.despaseguimiento.trim()
        : '';
      this.disabledBtn_enc =
        despaseguimiento &&
        this.paramApi_enc.localidad.locaid &&
        this.paramApi_enc.tecnico.tecnicoid
          ? false
          : true;
    }
  }

  handleValorEnc(): void {
    if (!this.paramApi_enc.despacargo_sino) {
      this.disabledFieldValue_enc = true;
      this.paramApi_enc.despacargo_valor = '';
      return;
    }
    this.disabledFieldValue_enc = false;
  }

  handleFormatValueEnc(): void {
    const validateLengthPrice = this.paramApi_enc.despacargo_valor.replace(
      /\./g,
      ''
    );
    if (validateLengthPrice.length > 10) {
      this.paramApi_enc.despacargo_valor = '';
      this.$snotify.error(
        'El campo valor solo permite como máximo 10 caracteres más un punto',
        { timeout: 3000 }
      );
      return;
    }
    const precio = this.paramApi_enc.despacargo_valor;
    if (precio.length === 10 && !precio.includes('.')) {
      this.paramApi_enc.despacargo_valor =
        precio.substring(0, 8) + '.' + precio.substring(8);
      return;
    }
    const decimales = precio.split('.')[1];
    if (decimales && decimales.length > 2) {
      this.paramApi_enc.despacargo_valor = precio.substring(
        0,
        precio.indexOf('.') + 3
      );
      return;
    }
    if (!precio.includes('.')) {
      this.paramApi_enc.despacargo_valor = precio + '.00';
    }
  }

  async insertEncomienda(): Promise<void> {
    const newEncomienda = {
      nombre_add: this.data.nombre_add,
      ...this.paramApi_enc,
    };
    try {
      this.loadingService.showLoading(null, 'insertEnc');
      const result = await fetchAdd({
        endpoint: 'query_insert_encomienda',
        body: { ...newEncomienda },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);
      if (cod !== 1) {
        this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        return;
      }
      this.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
      this.handleClosed({ reload: true });
    } catch (err) {
      this.$snotify.error('Ocurrió un error inesperado, por favor reintente', {
        timeout: 3000,
      });
      console.error('Error: ', err);
    } finally {
      this.loadingService.hideLoading('insertEnc');
    }
  }

  handlePopUp(): void {
    if (
      this.validateFieldEmpty_equipo.fecha_despacho &&
      !this.deviceList.length
    ) {
      this.handleClosed({});
      return;
    }
    this.dialogPopUp = true;
  }

  showPopuP(confirmation: boolean): void {
    this.dialogPopUp = !this.dialogPopUp;
    if (confirmation) {
      this.handleClosed({});
    }
  }

  handleClosed({ reload = false }: { reload?: boolean } = {}): void {
    this.$emit('cerrar', reload);
  }
}
